import { ImageConversionResult } from '../types';

export const convertFileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result);
      } else {
        reject(new Error('Ошибка чтения файла'));
      }
    };
    reader.onerror = () => reject(new Error(reader.error?.message || 'Ошибка чтения файла'));
    reader.readAsDataURL(file);
  });
};

export const convertUrlToBase64 = async (url: string): Promise<string> => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Ошибка загрузки изображения по URL (${response.status})`);
    }
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        if (typeof reader.result === 'string') {
          resolve(reader.result);
        } else {
          reject(new Error('Ошибка чтения blob'));
        }
      };
      reader.onerror = () => reject(new Error(reader.error?.message || 'Ошибка чтения файла'));
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    }
    throw new Error('Ошибка загрузки изображения по URL');
  }
};

export const convertBase64ToBlob = (base64: string): Blob => {
  const base64Data = base64.split(',')[1];
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: 'image/jpeg' });
};

export const processImageFile = async (file: File): Promise<ImageConversionResult> => {
  const base64 = await convertFileToBase64(file);
  const url = URL.createObjectURL(file);
  
  return {
    base64,
    url,
  };
};
